import * as React from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";

import {
  AccountCircleOutlined,
  DashboardOutlined,
  Inventory2Outlined,
  SelectAll,
  SettingsOutlined,
} from "@mui/icons-material";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";

import { ShopLotteryView } from "../../components";
import CommonContainer from "../../components/common/container/CommonContainer";
import SideBar from "../../components/Dashboard/SideBar";
import CreateAdvertisement from "../Admin/advertisements/CreateAdvertisement";
import EditAdvertisement from "../Admin/advertisements/EditAdvertisement";
import ViewAdvertisement from "../Admin/advertisements/ViewAdvertisement";
import ViewAdvertisements from "../Admin/advertisements/ViewAdvertisements";
import Setting from "../Setting";
import { hasInventoryManagement } from "../../utils/subscription";
import AddInventoryPage from "./Inventory/AddInventoryPage";
// OLD VERSION (route below is commented, replaced by InventoryV2Page):
// import FetchAllInventories from "./Inventory/FetchAllInventories";
import SalesInventoryPage from "./Inventory/SalesInventoryPage";
// OLD VERSION (route below is commented, replaced by SalesInsightsV2Page):
// import Statistics from "./Inventory/Statistics";
import InventoryV2Page from "./InventoryV2/InventoryV2Page"; // NEW inventory management version
import SalesInsightsV2Page from "./SalesInsightsV2/SalesInsightsV2Page"; // NEW sales insights version
import Profile from "./Profile";
import ViewAllSubscriptions from "./Subscriptions/ViewAllSubscriptions";

const ShopOwner: React.FC<{}> = () => {
  const { t } = useTranslation("translation");
  const sideBarList: any = [
    {
      list: t("dashboardSidebarTitle", "Dashboard"),
      navUrl: "/shopOwner/dashboard",
      icon: <DashboardOutlined sx={{ mr: 1 }} />,
    },
    {
      list: t("profileSidebarTitle", "Profile"),
      navUrl: "/shopOwner/profile",
      icon: <AccountCircleOutlined sx={{ mr: 1 }} />,
    },
    // {
    //   list: t("subscriptionSidebarTitle", "Subscriptions"),
    //   navUrl: "/shopOwner/subscriptions",
    //   icon: <SubscriptionsIcon sx={{ mr: 1 }} />,
    // },
    {
      list: t("settingsSidebarTitle", "Settings"),
      navUrl: "/shopOwner/setting",
      icon: <SettingsOutlined sx={{ mr: 1 }} />,
    },
    {
      list: t("selectionSidebarTitle", "Screen selection"),
      // Each screen opens in its own tab, and carries its screen number in the URL
      // so the tabs do not overwrite each other's choice (see /lottery?screen=N).
      sublist: [
        { label: t("screen", { screenCount: 1 }), navUrl: "/lottery?screen=1", newTab: true },
        { label: t("screen", { screenCount: 2 }), navUrl: "/lottery?screen=2", newTab: true },
        { label: t("dashboard", "Dashboard"), navUrl: "/shopOwner/dashboard" },
      ],
      navUrl: "/selection",
      icon: <SelectAll sx={{ mr: 1 }} />,
    },
  ];

  if (hasInventoryManagement()) {
    sideBarList.push(
      // {
      //   list: t("advertisementsSidebarTitle", "Advertisements"),
      //   navUrl: "/shopOwner/advertisements",
      //   icon: <SlideshowIcon sx={{ mr: 1 }} />,
      // },
      {
        list: t("inventorySidebarTitle", "Inventory Management"),
        sublist: [
          // OLD VERSION routing (kept for reference, no longer surfaced to users):
          // { name: "inventoryList", navUrl: "/shopOwner/fetchInventories" },
          // NEW VERSION routing -> redesigned Confirm/Inventory screen:
          { name: "inventoryList", navUrl: "/shopOwner/inventory" },
          // Shortcut straight to the Sales view of the same screen:
          { label: t("salesSidebarTitle", "Sales"), navUrl: "/shopOwner/inventory/sales" },
          // OLD VERSION Sales Management submenu, hidden from the sidebar (route kept below):
          // { name: "staticticsSidebar", navUrl: "/shopOwner/salesInventory" },
          // OLD VERSION routing (kept for reference, no longer surfaced to users):
          // { name: "salesInsights", navUrl: "/shopOwner/statistics" },
          // NEW VERSION routing -> redesigned Sales Insights v2 screen:
          { name: "salesInsights", navUrl: "/shopOwner/salesInsights" }
        ],
        // OLD VERSION: navUrl: "/shopOwner/fetchInventories",
        navUrl: "/shopOwner/inventory", // NEW VERSION
        icon: <Inventory2Outlined sx={{ mr: 1 }} />,
      },
    );
  }

  return (
    <SideBar sideBarList={sideBarList}>
      <Routes>
        <Route path={"/dashboard"} element={<ShopLotteryView />} />
        <Route path={"/profile"} element={<Profile />} />
        {/* OLD VERSION routing (kept, no longer linked from the sidebar): */}
        {/* <Route path={"/fetchInventories"} element={<FetchAllInventories />} /> */}
        {/* NEW VERSION routing -> redesigned inventory management: */}
        <Route path={"/inventory"} element={<InventoryV2Page />} />
        {/* same screen, opened straight on its Sales view */}
        <Route path={"/inventory/sales"} element={<InventoryV2Page initialView='sales' />} />
        <Route path={"/addInventory"} element={<AddInventoryPage />} />
        <Route path={"/salesInventory"} element={<SalesInventoryPage />} />
        {/* OLD VERSION routing (kept, no longer linked from the sidebar): */}
        {/* <Route path={"/statistics"} element={<Statistics />} /> */}
        {/* NEW VERSION routing -> redesigned Sales Insights v2: */}
        <Route path={"/salesInsights"} element={<SalesInsightsV2Page />} />
        <Route path={"/advertisements/create"} element={<CreateAdvertisement />} />
        <Route path={"/advertisements/edit/:id"} element={<EditAdvertisement />} />
        <Route path={"/advertisements/view/:id"} element={<ViewAdvertisement />} />
        <Route path={"/advertisements"} element={<ViewAdvertisements />} />
        <Route path={"/subscriptions"} element={<ViewAllSubscriptions />} />
        <Route
          path={"/setting"}
          element={
            <CommonContainer title={t("settings")} description={t("settingsDescription")}>
              <Setting />
            </CommonContainer>
          }
        />
      </Routes>
    </SideBar>
  );
};

export default ShopOwner;
